import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

interface NavigateOptions {
	replace?: boolean;
	state?: unknown;
	queryParams?: Record<string, string>;
}

const useLanguageNavigate = () => {
	const navigate = useNavigate();
	const { language } = useParams();

	const navigateWithLanguage = useCallback(
		(to: string, options?: NavigateOptions) => {
			// Split the 'to' path into base path and existing search params
			const [basePath, existingSearchParams] = to.split('?');

			// Create URLSearchParams instance
			const searchParams = new URLSearchParams(existingSearchParams);

			// Add additional query parameters if provided
			if (options?.queryParams) {
				Object.entries(options.queryParams).forEach(([key, value]) => {
					searchParams.set(key, value);
				});
			}

			// Construct the new path with language prefix
			let languagePath = `/${language}${basePath}`;

			// Add search params if they exist
			const searchParamsString = searchParams.toString();

			if (searchParamsString) {
				languagePath += `?${searchParamsString}`;
			}

			// Remove queryParams from options before passing to navigate
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			const { queryParams: _, ...navigateOptions } = options || {};

			navigate(languagePath, navigateOptions);
		},
		[language, navigate]
	);

	return { navigateWithLanguage };
};

export default useLanguageNavigate;
